"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
-- api_base is not used here due to the existing custom configuration
-- to the global axios object - specifically the base url pointing to
-- app2 for live data
--
-- this api creates a new instance of axios and points to stubbed data
-- in alexandria_api
--
-- whenever filters live data is available we'll have to update this
-- api to mimic the existing api's for organizations, users etc.
-- basically strip out the new axios object and use the configured global one
*/
var axios_1 = __importDefault(require("axios"));
exports.default = {
    get: function () {
        var instance = axios_1.default.create({
            method: 'get',
            baseURL: 'https://1490b5e7-7a1b-40b8-ba7e-553c2ce4e53d.mock.pstmn.io'
        });
        // withCredentials back to default configuration
        instance.defaults.withCredentials = false;
        return instance.get('/filters').then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=filters_api.js.map